export interface recipientProps {
  isPrimary: boolean;
  name: string;
  phoneNumber: string;
  id?: string;
  phoneType?: string;
  presenceStatus?: string;
  profileImageUrl?: string;
  type?: string;
  isDirectlyProceed?: boolean;
}
